export { default } from "./FavoriteStrainsSection";
